export const tinyMenuMetaData = {
    mobileOnly: true
}
